module.exports = __webpack_public_path__ + "8ec704faac7c017c0f49a42e3f677fe7.jpg";